import styled from 'styled-components'
import { Span } from '@sellpy/design-system-react-web'
import { mediaQueries } from '../uiComponents/mediaQueries'

export const WhiteBox = styled.div`
  width: calc(400px - 32px);
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.white.default};
  border-radius: 5px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.16);
  padding: 16px;
  margin: -161px auto 0 auto;
  ${mediaQueries.tablet} {
    margin: -114px auto 0 auto;
  }
  ${mediaQueries.phone} {
    width: 80%;
  }
`

export const BalanceInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const WhiteBoxContent = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  padding: 8px 0;
`

export const ColoredInfoBox = styled.div`
  border-radius: 5px;
  background-color: ${({ theme }) => theme.color.blue.shade10};
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.color.blue.shade1};
  display: flex;
`

export const InfoText = styled(Span)`
  color: ${({ theme }) => theme.color.blue.shade1};
`

export const PayoutActionContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`
export const WhiteBoxBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.color.grey.shade8};
  margin: 8px 0;
`

export const TipsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
